import React from 'react';
import moment from 'moment-timezone';
import lowerFirst from 'lodash/lowerFirst';
import Cookies from 'js-cookie';

export const STATES = [
  { name: 'Alabama', eligible: false },
  { name: 'Alaska', eligible: true },
  { name: 'Arizona', eligible: false },
  { name: 'Arkansas', eligible: false },
  { name: 'California', eligible: false },
  { name: 'Colorado', eligible: false },
  { name: 'Connecticut', eligible: false },
  { name: 'Delaware', eligible: false },
  { name: 'Florida', eligible: false },
  { name: 'Georgia', eligible: false },
  { name: 'Hawaii', eligible: false },
  { name: 'Idaho', eligible: false },
  { name: 'Illinois', eligible: false },
  { name: 'Indiana', eligible: false },
  { name: 'Iowa', eligible: false },
  { name: 'Kansas', eligible: false },
  { name: 'Kentucky', eligible: false },
  { name: 'Louisiana', eligible: false },
  { name: 'Maine', eligible: false },
  { name: 'Maryland', eligible: false },
  { name: 'Massachusetts', eligible: false },
  { name: 'Michigan', eligible: false },
  { name: 'Minnesota', eligible: false },
  { name: 'Mississippi', eligible: false },
  { name: 'Missouri', eligible: false },
  { name: 'Montana', eligible: false },
  { name: 'Nebraska', eligible: false },
  { name: 'Nevada', eligible: false },
  { name: 'New Hampshire', eligible: false },
  { name: 'New Jersey', eligible: false },
  { name: 'New Mexico', eligible: false },
  { name: 'New York', eligible: false },
  { name: 'North Carolina', eligible: false },
  { name: 'North Dakota', eligible: false },
  { name: 'Ohio', eligible: false },
  { name: 'Oklahoma', eligible: false },
  { name: 'Oregon', eligible: true },
  { name: 'Pennsylvania', eligible: false },
  { name: 'Rhode Island', eligible: false },
  { name: 'South Carolina', eligible: false },
  { name: 'South Dakota', eligible: false },
  { name: 'Tennessee', eligible: false },
  { name: 'Texas', eligible: false },
  { name: 'Utah', eligible: false },
  { name: 'Vermont', eligible: false },
  { name: 'Virginia', eligible: false },
  { name: 'Washington', eligible: true },
  { name: 'West Virginia', eligible: false },
  { name: 'Wisconsin', eligible: false },
  { name: 'Wyoming', eligible: false },
];

export const REFERRERS = [
  { label: 'Word of mouth', value: 'Word of Mouth' },
  { label: 'Word of mouth: a Boulder patient', value: 'A Boulder Patient' },
  {
    label: 'A Boulder employee (community outreach, presentation, in-person event)',
    value: 'A Boulder Employee',
  },
  { label: 'Web search', value: 'Web search' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Instagram', value: 'Instagram' },
  { label: 'My insurance company', value: 'Insurer' },
  { label: 'My employer', value: 'My Employer' },
  { label: 'Another medical or SUD provider/treatment facility', value: 'Another Facility' },
  { label: 'ED or Inpatient/hospital referral', value: 'ED or Inpatient/hospital referral' },
  { label: 'Legal system: Corrections, drug court, parole officer', value: 'Legal system' },
  { label: 'Other', value: 'Other' },
];

export const REFERRAL_REASON = [
  { label: 'AUD', value: 'aud' },
  { label: 'OUD', value: 'oud' },
  { label: 'Both', value: 'both' },
];

const TIMEZONE = 'America/Los_Angeles';

export const UTMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

const APPLE_APP_STORE_URL = 'https://apps.apple.com/us/app/boulder-care/id1437606990';
const ANDROID_APP_STORE_URL = 'https://play.google.com/store/apps/details?id=bouldercare.patient';

export function getScheduleOptions(availableSlots = [], excludeHours = []) {
  return availableSlots
    .filter((slotTime) => {
      const m = moment(slotTime).tz(TIMEZONE);
      return !excludeHours.includes(m.hours());
    })
    .map((slotTime) => {
      return {
        value: moment.tz(slotTime, 'UTC').format(),
        label: formatLocalTime(slotTime, true),
      };
    });
}

export function formatLocalTime(date, capitalize = false) {
  const local = moment.tz(date, moment.tz.guess());
  const ret = `${local.calendar()} ${local.zoneAbbr()}`;
  return capitalize ? ret : lowerFirst(ret);
}

export function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

export function submitForm(submitEvent, files = [], onComplete, onError, jsonp = false) {
  submitEvent.preventDefault();
  const form = submitEvent.target;
  const formProps = {
    type: 'POST',
    url: window.$(form).attr('action'),
    processData: false,
    contentType: false,
    dataType: null,
  };

  // Mailchimp wasn't reading the form data correctly for the whitepaper forms and they are why we use jsonp
  // Having these settings solved the problem
  if (jsonp) {
    formProps.data = window.$(form).serialize();
    formProps.contentType = 'application/json';
    formProps.processData = true;
    formProps.dataType = 'jsonp';
  } else {
    const formData = new FormData(form);
    files.forEach((file) => formData.append('files', file));
    formProps.data = formData;
  }

  window.$.ajax(formProps)
    .done((data) => {
      // Ideally would return a promise for chaining, but jQuery uses its own deferred type
      // so this seems easier...
      onComplete(data);
    })
    .fail(() => {
      // This shouldn't ever happen so don't bother building something nice
      // eslint-disable-next-line no-alert
      alert(
        'An unexpected error occurred - please try again later, or let us know at contact@boulder.care.',
      );
      if (onError) {
        onError();
      }
    });
}

/**
 * React hook for 2 pass rendering. Returns false on initial render (or server-side render), and then
 * true for the next render. See https://joshwcomeau.com/react/the-perils-of-rehydration/ for details
 * of why this is needed for proper hydration.
 */
export function useHasMounted() {
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
}

/**
 * Get the GA Client ID.
 *
 * I originally tried to grab this from ga.getAll()[0].get('clientId'), but since we use
 * GTM, it was tough to get the timing right where that gets called after ga is defined and
 * the trackers exist -- where the cookie always seems to be defined ahead of this code.
 */
export function getGaClientId() {
  const cookie = Cookies.get('_ga');
  const matches = cookie && cookie.match(/\d+\.\d+$/);
  return matches && matches[0];
}

/**
 * Builds a deep-link to the app, which, on mobile, will open the app if
 * installed, or go to the app store to prompt to download it, and grab
 * the tracking parameters along the way. On desktop, this will just go
 * to a page prompting the person to download the app.
 */
export function getAppStoreLink(platformHash) {
  if (platformHash === '#appstore_ios') {
    return APPLE_APP_STORE_URL;
  } else if (platformHash === '#appstore_android') {
    return ANDROID_APP_STORE_URL;
  } else {
    throw Error('Unidentified app store');
  }
}
